export default [
  {
    id: 0,
    nome: "Natours",
    dev: false,
    categorias: ["all", "web", "html"],
    img: "natours/nat-1.jpg",
    carrosselImg: [
      "natours/nat-2.jpg",
      "natours/nat-3.jpg",
      "natours/nat-4.jpg",
      "natours/nat-5.jpg",
      "natours/nat-6.jpg",
      "natours/nat-gif.gif",
    ],
  },

  {
    id: 1,
    nome: "Trillo",
    githubLink: "",
    dev: false,
    testeLink: "",
    categorias: ["all", "web", "html"],
    img: "trillo/tri-1.jpg",
    carrosselImg: ["trillo/tri-2.jpg", "trillo/tri.gif"],
  },
  {
    id: 2,
    nome: "Calculator UI",
    link:
      "",
    dev: false,
    categorias: ["all", "design"],
    img: "calculator/bg.png",
    carrosselImg: ["calculator/bg.png"],
  },
  {
    id: 3,
    nome: "my-lista",
    link:
      "",
    dev: true,
    categorias: ["all", "design", "mobile"],
    img: "my-lista/my-lista.png",
    carrosselImg: ["my-lista/my-lista.png"],
  },
]
